import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { VIEWER_FRAGMENT, ViewerFragment } from "../../fragments";

export const GET_VIEWER = gql`
  query getViewer {
    viewer {
      ...ViewerFragment
    }
  }
  ${VIEWER_FRAGMENT}
`;

export type ViewerData = { viewer: ViewerFragment };

export default (
  options?: QueryHookOptions<ViewerData, null>
) => {
  return useQuery<ViewerData, null>(GET_VIEWER, options);
};